import React, { FunctionComponent, useState } from 'react'
import styles from './ProjectFiltersDesktop.module.sass'
import { isDefinedRecord, isDefinedTuple, toggle } from '../../../../../../utils/utils'
import { Checkbox } from '../../../../../controls/Checkbox/Checkbox'
import { Classes, Colors } from '../../../../../../styles'
import { ProjectStatus, projectStatusToColor, projectStatusToName } from '../../../../../../responses/projects'
import Spacer from '../../../../../etc/Spacer'
import { eqNumber } from 'fp-ts/es6/Eq'
import { RequestStatus } from '../../../../../../responses/response'
import Button, { ButtonStyle } from '../../../../../controls/Button/Button'
import { SortDirection } from '../../../../../../constants/direction'
import SortIcon from '../../../../../../../files/sort.svg'
import clsx from 'clsx'
import Tooltip from 'react-tooltip-lite'
import { refsConfig, sortFilters } from '../filters'
import Splitter from '../../../../../etc/Splitter/Splitter'
import Field from '../../../../../controls/Field/Field'
import SearchIcon from '../../../../../../../files/search.svg'
import TagPicker from '../../../../../data-components/tags/TagPicker/TagPicker'
import FiltersIcon from '../../../../../../../files/filters.svg'
import FiltersClearIcon from '../../../../../../../files/filters-clear.svg'
import PopupFilters from './PopupFilters'
import Dropdown from '../../../../../data-components/dropdowns/Dropdown/Dropdown'
import { ProjectFiltersProps } from '../props'

export const statusToggle = toggle<ProjectStatus>(eqNumber)

const ProjectFiltersDesktop: FunctionComponent<ProjectFiltersProps> = props => {
    const [open, setOpen] = useState(false)
    const filters = props.value
    const active = isDefinedRecord(filters.dropdowns) || isDefinedTuple(filters.openedAt)

    return <div className={styles.filters}>
        <div className={styles.main}>
            <Checkbox
                reversed
                color={Colors.darkGrey}
                value={filters.projectStatus.length === props.statusFilters.length}
                onChange={value => props.onChange({projectStatus: value ? props.statusFilters : []})}
            >
                Все
            </Checkbox>
            <div className={Classes.f13b}>Проекты</div>
            {
                props.statusFilters.map(status => <Checkbox
                    key={status}
                    value={filters.projectStatus.includes(status)}
                    color={projectStatusToColor(status)}
                    onChange={() => props.onChange({projectStatus: statusToggle(status)(filters.projectStatus)})}
                >
                    {projectStatusToName(status)}
                </Checkbox>)
            }
            <Spacer/>
            {props.actions}
        </div>

        <div className={styles.core}>
            <div className={styles.content}>
                <div className={styles.toggle}>{props.toggle}</div>
                <div>Показано проектов:</div>
                <div className={Classes.f13b}>
                    {status === RequestStatus.FETCHING && props.total === 0 ? '...' : props.total}
                </div>
                <Spacer/>
                <div className={styles.splitter}/>
                <Button
                    title={filters.sortDirection === SortDirection.ASC ? 'Сортировка по возрастанию' : 'Сортировка по убыванию'}
                    onClick={() => props.onChange({
                        sortDirection: filters.sortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC
                    })}
                >
                    <SortIcon className={clsx({[Classes.flip]: filters.sortDirection === SortDirection.ASC})}/>
                </Button>
                <Tooltip content={'Поле для сортировки'}>
                    <Dropdown
                        data={sortFilters}
                        selected={[filters.sortField]}
                        onClick={sortField => props.onChange({
                            sortField: filters.sortField === sortField? undefined: sortField
                        })}
                        content={() => filters.sortField?.name ?? 'По умолчанию'}
                        render={item => item?.name ?? 'По умолчанию'}
                        toKey={item => item?.key ?? 0}
                    />
                    {/*<Dropdown*/}
                    {/*    borderless*/}
                    {/*    items={sortFilters}*/}
                    {/*    selected={[filters.sortField]}*/}
                    {/*    itemToKey={item => item?.key ?? 0}*/}
                    {/*    onChange={sortField => props.onChange({*/}
                    {/*        sortField: filters.sortField === sortField? undefined: sortField*/}
                    {/*    })}*/}
                    {/*    renderer={item => item?.name ?? 'По умолчанию'}*/}
                    {/*/>*/}
                </Tooltip>
                <Splitter/>
                <Field
                    className={styles.search}
                    type={'text'}
                    placeholder={'Поиск'}
                    rightItem={<SearchIcon/>}
                    value={filters.search}
                    onChange={search => props.onChange({search})}
                />
                <Splitter/>
                <TagPicker
                    value={filters.tags}
                    onChange={tags => props.onChange({tags})}
                />
                <Button
                    title={open ? 'Скрыть фильтры' : 'Показать фильтры'}
                    buttonStyle={active ? ButtonStyle.DEFAULT : ButtonStyle.TINTED}
                    active={active || open}
                    onClick={() => setOpen(!open)}
                >
                    <FiltersIcon/>
                </Button>
                <Button
                    title={'Очистить фильтры'}
                    onClick={props.onClear}
                >
                    <FiltersClearIcon/>
                </Button>

            </div>
        </div>

        <PopupFilters open={open} filters={filters} config={refsConfig} onChange={props.onChange}/>
    </div>
}

export default ProjectFiltersDesktop